import React, { useState } from "react";
import styled from "styled-components";
import Moment from "moment";

const SectionLabel = styled.span`
  width: 100%;
  display: inline-block;
  float: left;
  font-size: 2rem;
  @media only screen and (min-width: 600px) {
    width: 100%;
    display: inline-block;
    float: left;
    font-size: 2rem;
  }
`;

const MainContainer = styled.div`
  width: 100%;
  display: inline-block;
  float: left;
  @media only screen and (min-width: 600px) {
  }
`;

const SubContainer = styled.div`
  width: 100%;
  float: left;
  @media only screen and (min-width: 600px) {
    float: left;
    width: 96%;
    margin: 2%;
  }
`;

const Block = styled.button`
  width: 98%;
  margin: 2%;
  float: left;
  @media only screen and (min-width: 600px) {
    float: left;
    width: 23%;
    margin: 2%;
    text-align: center;
    padding: 1%;
    border-radius: 2rem;
    background: ${(props) => (props.isSelected ? "#8e1cff" : "#009CAB")};
  }
`;

export default (props) => {
  const date = new Date();
  const daysOut = [1, 2, 3, 4, 5];
  const availableTimes = [2, 3, 4, 5];
  const [daySelected, setDaySelected] = useState(false);
  const [timeSelected, setTimeSelected] = useState(false);
  const [selectedDate, setDate] = useState();
  const [selectedDayButton, setSelectedDayButton] = useState();
  const [selectedTimeButton, setSelectedTimeButton] = useState();
  const [today, _] = useState(new Date());

  const setDay = (selected, newDate) => {
    setSelectedDayButton(selected);
    setSelectedTimeButton("time-0");
    setDaySelected(true);
    setTimeSelected(false);
    let tempDate = new Date(newDate);
    tempDate.setHours(12 + availableTimes[0]);
    tempDate.setMinutes(0);
    setDate(tempDate);
    props.pickupTimeCallback(Moment(tempDate).toISOString());
  };

  const setTime = (selected, hour) => {
    setSelectedTimeButton(selected);
    setTimeSelected(true);
    var newDate = new Date(selectedDate);
    newDate.setHours(12 + hour);
    newDate.setMinutes(0);
    setDate(newDate);
    props.pickupTimeCallback(Moment(newDate).toISOString());
  };

  return (
    <MainContainer>
      <SubContainer>
        <SectionLabel>Select Day</SectionLabel>
        {daysOut.map((plusDay, index) => {
          // console.log(new Date().setDate(today.getDate() + plusDay));
          return (
            <Block
              onClick={() =>
                setDay(
                  "day-" + index,
                  new Date().setDate(today.getDate() + plusDay)
                )
              }
              isSelected={"day-" + index == selectedDayButton}
            >
              {Moment(new Date().setDate(today.getDate() + plusDay)).format(
                "MMMM Do YYYY"
              )}
            </Block>
          );
        })}
      </SubContainer>
      <SubContainer>
        <SectionLabel>Select Time</SectionLabel>
        {availableTimes.map((timeSlot, index) => {
          return (
            <Block
              disabled={!daySelected}
              onClick={() => setTime("time-" + index, timeSlot)}
              isSelected={"time-" + index == selectedTimeButton}
            >
              {timeSlot}:00 PM{" "}
            </Block>
          );
        })}
      </SubContainer>
      <p>
        Your Pickup Time is: {Moment(selectedDate).format("ddd MMM Do hh:mm A")}
      </p>
    </MainContainer>
  );
};
